import { render, staticRenderFns } from "./message.vue?vue&type=template&id=0a482195&scoped=true&"
import script from "./message.vue?vue&type=script&lang=ts&"
export * from "./message.vue?vue&type=script&lang=ts&"
import style0 from "./message.vue?vue&type=style&index=0&id=0a482195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a482195",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a482195')) {
      api.createRecord('0a482195', component.options)
    } else {
      api.reload('0a482195', component.options)
    }
    module.hot.accept("./message.vue?vue&type=template&id=0a482195&scoped=true&", function () {
      api.rerender('0a482195', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "core/plugin/toasts/vue/message.vue"
export default component.exports